const flyoutContainer = document.querySelector('.flyout-container');
const flyoutPanels = Array.from(document.querySelectorAll('[data-flyout-panel]'));
const flyoutTriggers = Array.from(document.querySelectorAll('[data-flyout-target]'));
const flyoutDialog = document.querySelector('#flyout');
const closeButton = document.querySelector('[data-flyout-close]');
let closeAnimationEndHandler = null;
let lastFlyoutTrigger = null;
let flyoutTrapHandler = null;

const mobileNavContainer = document.querySelector('#mobile-nav');
const mobileNavToggle = document.querySelector('#mobile-nav-toggle');
const mobileNavClose = document.querySelector('#mobile-nav-close');
const mobileNavMain = document.querySelector('#mobile-nav-main');
const mobileNavBack = document.querySelector('#mobile-nav-back');
const mobileSubnavTriggers = Array.from(document.querySelectorAll('[data-mobile-subnav-target]'));
const mobileSubnavPanels = Array.from(document.querySelectorAll('[data-mobile-subnav-panel]'));
const mobileSubnavToggles = Array.from(document.querySelectorAll('[data-mobile-subnav-toggle]'));
let mobileNavCloseAnimationEndHandler = null;
let mobileNavTrapHandler = null;
let lastMobileNavTrigger = null;

function getFocusable(container)
{
    if (!container) return [];

    return Array.from(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
        .filter(el => !el.closest('[hidden]') && el.offsetParent !== null);
}

function trapTabWithin(container)
{
    return (ev) =>
    {
        if (ev.key !== 'Tab') return;

        const focusable = getFocusable(container);

        if (focusable.length === 0) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (ev.shiftKey && document.activeElement === first)
        {
            ev.preventDefault();
            last.focus();
        }
        else if (!ev.shiftKey && document.activeElement === last)
        {
            ev.preventDefault();
            first.focus();
        }
    };
}

//
export const initNavigation = () =>
{
    if (flyoutContainer && closeButton && flyoutTriggers.length > 0 && flyoutPanels.length > 0)
    {
        flyoutTriggers.forEach(trigger =>
        {
            trigger.addEventListener('click', (ev) =>
            {
                const targetId = trigger.dataset.flyoutTarget;
                const targetPanel = flyoutPanels.find(panel => panel.dataset.flyoutPanel === targetId);

                if (!targetId || !targetPanel)
                {
                    return;
                }

                ev.preventDefault();

                if (trigger.getAttribute('aria-expanded') === 'true')
                {
                    closeFlyout();
                    return;
                }

                lastFlyoutTrigger = trigger;
                openFlyout(targetId);
            });
        });

        closeButton.addEventListener('click', (ev) =>
        {
            ev.preventDefault();
            closeFlyout();
        });

        flyoutContainer.addEventListener('click', (ev) =>
        {
            if (ev.target === flyoutContainer)
            {
                closeFlyout();
            }
        });
    }

    if (mobileNavContainer && mobileNavToggle && mobileNavClose)
    {
        mobileNavToggle.addEventListener('click', () =>
        {
            if (mobileNavToggle.getAttribute('aria-expanded') === 'true')
            {
                closeMobileNav();
            }
            else
            {
                lastMobileNavTrigger = mobileNavToggle;
                openMobileNav();
            }
        });

        mobileNavClose.addEventListener('click', () =>
        {
            closeMobileNav();
        });

        mobileNavContainer.addEventListener('click', (ev) =>
        {
            if (ev.target === mobileNavContainer)
            {
                closeMobileNav();
            }
        });

        mobileSubnavTriggers.forEach(trigger =>
        {
            trigger.addEventListener('click', (ev) =>
            {
                ev.preventDefault();
                openMobileSubnav(trigger.dataset.mobileSubnavTarget);
            });
        });

        if (mobileNavBack)
        {
            mobileNavBack.addEventListener('click', () =>
            {
                closeMobileSubnav();
            });
        }

        mobileSubnavToggles.forEach(toggle =>
        {
            toggle.addEventListener('click', () =>
            {
                const li = toggle.closest('li');
                const list = li?.querySelector('.third');

                if (!list)
                {
                    return;
                }

                const isOpen = toggle.getAttribute('aria-expanded') === 'true';

                // close all sub-navigations, then open the clicked one (accordion)
                resetMobileSubnavToggles();

                if (!isOpen)
                {
                    toggle.setAttribute('aria-expanded', 'true');
                    li.classList.add('is-open');
                    list.hidden = false;
                }
            });
        });
    }

    document.addEventListener('keydown', (ev) =>
    {
        if (ev.key === 'Escape')
        {
            if (document.body.classList.contains('flyout-open'))
            {
                closeFlyout();
            }

            if (document.body.classList.contains('mobile-nav-open'))
            {
                closeMobileNav();
            }
        }
    });
};

function openFlyout(targetId)
{
    const targetPanel = flyoutPanels.find(panel => panel.dataset.flyoutPanel === targetId);

    if (!targetPanel)
    {
        closeFlyout();
        return;
    }

    flyoutPanels.forEach(panel =>
    {
        panel.hidden = panel !== targetPanel;
    });

    flyoutTriggers.forEach(trigger =>
    {
        const isActive = trigger.dataset.flyoutTarget === targetId;

        trigger.setAttribute('aria-expanded', String(isActive));
        trigger.closest('li')?.classList.toggle('is-open', isActive);
    });

    if (closeAnimationEndHandler)
    {
        flyoutContainer.removeEventListener('animationend', closeAnimationEndHandler);
        closeAnimationEndHandler = null;
    }

    flyoutContainer.classList.remove('is-closing');
    flyoutContainer.classList.add('is-open');
    flyoutContainer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('flyout-open');

    closeButton?.focus();

    if (flyoutTrapHandler)
    {
        document.removeEventListener('keydown', flyoutTrapHandler);
    }

    flyoutTrapHandler = trapTabWithin(flyoutDialog);
    document.addEventListener('keydown', flyoutTrapHandler);
}

function closeFlyout()
{
    flyoutTriggers.forEach(trigger =>
    {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.closest('li')?.classList.remove('is-open');
    });

    flyoutContainer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('flyout-open');

    if (flyoutTrapHandler)
    {
        document.removeEventListener('keydown', flyoutTrapHandler);
        flyoutTrapHandler = null;
    }

    lastFlyoutTrigger?.focus();

    flyoutContainer.classList.remove('is-open');
    flyoutContainer.classList.add('is-closing');

    if (closeAnimationEndHandler)
    {
        flyoutContainer.removeEventListener('animationend', closeAnimationEndHandler);
    }

    closeAnimationEndHandler = (event) =>
    {
        if (event.target !== flyoutContainer || event.animationName !== 'flyout-out')
        {
            return;
        }

        flyoutContainer.classList.remove('is-closing');
        flyoutContainer.removeEventListener('animationend', closeAnimationEndHandler);
        closeAnimationEndHandler = null;

        flyoutPanels.forEach(panel =>
        {
            panel.hidden = true;
        });
    };

    flyoutContainer.addEventListener('animationend', closeAnimationEndHandler);
}

function openMobileNav()
{
    if (mobileNavCloseAnimationEndHandler)
    {
        mobileNavContainer.removeEventListener('animationend', mobileNavCloseAnimationEndHandler);
        mobileNavCloseAnimationEndHandler = null;
    }

    mobileNavContainer.classList.remove('is-closing');
    mobileNavContainer.classList.add('is-open');
    mobileNavContainer.setAttribute('aria-hidden', 'false');
    mobileNavToggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mobile-nav-open');

    mobileNavClose?.focus();

    if (mobileNavTrapHandler)
    {
        document.removeEventListener('keydown', mobileNavTrapHandler);
    }

    mobileNavTrapHandler = trapTabWithin(mobileNavContainer);
    document.addEventListener('keydown', mobileNavTrapHandler);
}

function closeMobileNav()
{
    closeMobileSubnav();

    mobileNavContainer.setAttribute('aria-hidden', 'true');
    mobileNavToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('mobile-nav-open');

    if (mobileNavTrapHandler)
    {
        document.removeEventListener('keydown', mobileNavTrapHandler);
        mobileNavTrapHandler = null;
    }

    lastMobileNavTrigger?.focus();

    mobileNavContainer.classList.remove('is-open');
    mobileNavContainer.classList.add('is-closing');

    if (mobileNavCloseAnimationEndHandler)
    {
        mobileNavContainer.removeEventListener('animationend', mobileNavCloseAnimationEndHandler);
    }

    mobileNavCloseAnimationEndHandler = (event) =>
    {
        if (event.target !== mobileNavContainer || event.animationName !== 'mobile-nav-out')
        {
            return;
        }

        mobileNavContainer.classList.remove('is-closing');
        mobileNavContainer.removeEventListener('animationend', mobileNavCloseAnimationEndHandler);
        mobileNavCloseAnimationEndHandler = null;
    };

    mobileNavContainer.addEventListener('animationend', mobileNavCloseAnimationEndHandler);
}

function openMobileSubnav(targetId)
{
    resetMobileSubnavToggles();

    mobileSubnavPanels.forEach(panel =>
    {
        panel.hidden = panel.dataset.mobileSubnavPanel !== targetId;
    });

    if (mobileNavMain) mobileNavMain.hidden = true;
    if (mobileNavBack) mobileNavBack.hidden = false;
}

function closeMobileSubnav()
{
    mobileSubnavPanels.forEach(panel =>
    {
        panel.hidden = true;
    });

    resetMobileSubnavToggles();

    if (mobileNavMain) mobileNavMain.hidden = false;
    if (mobileNavBack) mobileNavBack.hidden = true;
}

function resetMobileSubnavToggles()
{
    mobileSubnavToggles.forEach(toggle =>
    {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.closest('li')?.classList.remove('is-open');

        const list = toggle.closest('li')?.querySelector('.third');
        if (list) list.hidden = true;
    });
}
